import { FullscreenSlider } from './classes/fs-slider';
export default class FullscreenSlidersService {
    constructor() {
        this.sliders = {};
    }
    init(Sliders, mainSwiper) {
        document.querySelectorAll('[data-fs-slider]').forEach((fsSlider) => {
            const fsSliderId = fsSlider.getAttribute('data-fs-slider');
            if (!fsSliderId) {
                return;
            }
            if (typeof this.sliders[fsSliderId] === 'undefined') {
                const element = new FullscreenSlider(fsSliderId);
                const swiper = Sliders.initFsSlider(`#${fsSliderId}`, mainSwiper);
                this.sliders[fsSliderId] = { element, swiper };
                if (mainSwiper) {
                    mainSwiper.controller.control = swiper;
                }
            }
            fsSlider.addEventListener('click', () => {
                if (this.sliders[fsSliderId]) {
                    this.sliders[fsSliderId].element.open();
                    this.sliders[fsSliderId].swiper.update();
                }
            });
        });
    }
}
